import React from 'react';
import './StarlinkHero.scss';

const StarlinkHero: React.FC = () => {
  const handleRequestQuote = () => {
    window.location.href = 'mailto:sales@shadowtracker.com?subject=Starlink Fleet Quote Request';
  };

  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="starlink-hero" id="starlink-hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">⚡</span>
            <span>Enterprise Fleet Solution</span>
          </div>
          
          <h1>Starlink Tracker</h1>
          <p className="hero-subtitle">Professional fleet management meets undetectable backup protection</p>
          
          <div className="hero-features">
            <div className="feature-item">
              <span className="feature-icon">🔌</span>
              <span>Hardwired Installation</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📊</span>
              <span>Fleet Management</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🛡️</span>
              <span>Dual Protection</span>
            </div>
          </div>

          <div className="hero-cta">
            <button className="cta-primary" onClick={handleRequestQuote}>
              Request Quote
              <span className="arrow">→</span>
            </button>
            <button className="cta-secondary" onClick={scrollToPricing}>
              View Pricing
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">300+</span>
              <span className="stat-label">Fleet Vehicles</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Live Monitoring</span>
            </div>
            <div className="stat">
              <span className="stat-number">99.9%</span>
              <span className="stat-label">Uptime</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StarlinkHero;
